import { render, staticRenderFns } from "./AHVLogo.vue?vue&type=template&id=4240cc12&"
import script from "./AHVLogo.vue?vue&type=script&lang=js&"
export * from "./AHVLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports